import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function CMSLogin() {
  const navigate = useNavigate();
  const { login, loading, error } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLocalError('');

    if (!email || !password) {
      setLocalError('Email and password are required');
      return;
    }

    try {
      await login(email, password);
      navigate('/cms/dashboard');
    } catch (err) {
      setLocalError(err instanceof Error ? err.message : 'Login failed');
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-dark">
      <div className="w-full max-w-md px-6">
        <div className="bg-brand-sand rounded-2xl shadow-2xl p-10">
          {/* Header with Logo */}
          <div className="text-center mb-10">
            <img 
              src="/Logo-Black-Simple.svg" 
              alt="Camila Parente" 
              className="h-20 mx-auto mb-6"
            />
            <h1 className="text-2xl font-bold text-brand-dark tracking-wide">
              CMS Administrator
            </h1>
            <p className="text-brand-gray text-sm mt-2">Secure Access Portal</p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Email Input */}
            <div>
              <label htmlFor="email" className="block text-sm font-semibold text-brand-dark mb-2">
                Email Address
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@camilaparente.store"
                className="w-full px-4 py-3 border-2 border-brand-dark/20 rounded-lg focus:ring-2 focus:ring-brand-blue focus:border-transparent bg-white/80 backdrop-blur-sm outline-none transition text-brand-dark placeholder:text-brand-gray"
                disabled={loading}
              />
            </div>

            {/* Password Input */}
            <div>
              <label htmlFor="password" className="block text-sm font-semibold text-brand-dark mb-2">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="w-full px-4 py-3 border-2 border-brand-dark/20 rounded-lg focus:ring-2 focus:ring-brand-blue focus:border-transparent bg-white/80 backdrop-blur-sm outline-none transition text-brand-dark placeholder:text-brand-gray"
                disabled={loading}
              />
            </div>

            {/* Error Messages */}
            {(error || localError) && (
              <div className="bg-red-100 border-2 border-red-300 rounded-lg p-4">
                <p className="text-sm text-red-800 font-medium">{error || localError}</p>
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-brand-blue hover:bg-brand-dark disabled:bg-brand-gray text-brand-sand font-bold py-3 px-6 rounded-lg transition duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              {loading ? 'Logging in...' : 'Log In'}
            </button>
          </form>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t-2 border-brand-dark/10">
            <p className="text-center text-xs text-brand-gray">
              🔒 Secure login · Session expires in 7 days
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
